module.exports = __webpack_public_path__ + "img/img12.bda9ab8b.png";